/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Modelo} from '../../models/modelo'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";
import {ModeloDescSCH} from "../../search/ModeloSCH";

const url = '/modelos'

const state = {
  all: [],
  allList: [],
  modelo: new Modelo(),
  filtro: new Filtro()
}

const getters = {
  listaAllModelos: (state) => {
    return state.allList
  },

  listaModelos: (state) => {
    return state.all
  },
  pegaModelo: (state) => {
    return state.modelo
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
  state.filtro.filters.addSearch(['modelos.descr','marcas.descr'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {modelos_id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('modelo_id', modelos_id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_MODELO', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', ModeloDescSCH(perPage))
  },

  async setAllListModelos({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
  },
  async setAllModelos({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_MODELOS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarModelo({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.modelo, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setModelo({commit}, modelo) {
    commit('SET_MODELO', modelo)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_MODELOS(state, modelos) {
    state.all = modelos
  },
  SET_MODELO(state, modelo) {
    state.modelo = modelo
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
